import React, { useEffect } from "react";
import TopBaner from "../TopBaner/TopBaner";
import QuickButtons from "./QuickButtons/QuickButtons";
import { connectPromotions } from "./Promotion.connect";
import {
  quickButtonData,
  promotionBanner,
} from "../../constants/promotionData";
import TrendingGames from "./TrendingGames/TrendingGames";
import HomeCasinoGrid from "../HomeCasinoGridList/HomeCasinoGrid";
import leftSideMenuMapper from "../../helpers/getLeftSideMenuMapper.helper";
import { USER_DATA } from "../../config/app.config";
import GameShow from "./GameShow/GameShow";

const Promotion = ({ promotions, actions, user, auth, menu }) => {
  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  const existingGame = JSON.parse(localStorage.getItem(userData?._id)) || [];

  useEffect(() => {
    if (auth) {
      actions.requestPromotions();
      actions.requestSocials();
    } else {
      actions.requestPromotions();
      actions.requestNoAuthSocials();
    }
  }, [auth]);

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  return (
    <>
      {promotions?.slider && promotions?.slider.length >= 1 ? (
        <TopBaner inPlaySlidingBanners={promotions?.slider} />
      ) : (
        ""
      )}
      {/* {promotionBanner?.length >= 1 ? <TopBaner inPlaySlidingBanners={promotionBanner} /> : ''} */}
      {isSportAvailable("QT") ? (
        <>
          {quickButtonData?.length >= 1 ? (
            <QuickButtons quickButtons={quickButtonData} auth={auth} />
          ) : (
            ""
          )}

          {auth && Array.isArray(existingGame) && existingGame.length > 0 && (
            <HomeCasinoGrid
              itemHeaderData={leftSideMenuMapper["Continue to Play"]}
            />
          )}

          <TrendingGames />
          <GameShow />
        </>
      ) : null}
    </>
  );
};

export default connectPromotions()(Promotion);
